import type { ApiErrorCodeI18nPatternRule } from "./error-code-i18n-pattern-types";

// Access/session error-code i18n pattern rules.
export const API_ERROR_CODE_I18N_ACCESS_PATTERN_RULES: readonly ApiErrorCodeI18nPatternRule[] = [
  {
    prefix: "aitest.auth.",
    resourceI18nKey: "common.errors.apiCodeResources.aitestAuth",
    reasonCodes: [
      "app_session_required",
      "application_access_denied",
      "authorization_prompt_invalid",
      "invalid_app_session",
      "invalid_return_path",
      "invalid_sso_bff_response",
      "oidc_request_failed",
      "oidc_transaction_missing",
      "redirect_uri_not_configured",
      "sso_bff_not_configured",
    ],
  },
  {
    prefix: "ctf.auth.",
    resourceI18nKey: "common.errors.apiCodeResources.ctfAuth",
    reasonCodes: [
      "admin_access_required",
      "app_session_required",
      "application_access_denied",
      "application_context_invalid",
      "authorization_prompt_invalid",
      "invalid_app_session",
      "invalid_return_path",
      "invalid_sso_bff_response",
      "invalid_sso_user_payload",
      "invalid_token",
      "missing_bearer_token",
      "oidc_request_failed",
      "oidc_transaction_missing",
      "redirect_uri_not_configured",
      "sso_bff_not_configured",
      "sso_integration_disabled",
      "sso_unavailable",
      "teacher_access_required",
    ],
  },
  {
    prefix: "edu.auth.",
    resourceI18nKey: "common.errors.apiCodeResources.eduAuth",
    reasonCodes: [
      "admin_access_required",
      "invalid_sso_user_payload",
      "invalid_token",
      "missing_bearer_token",
      "sso_bootstrap_failed",
      "sso_integration_disabled",
      "sso_unavailable",
    ],
  },
  {
    prefix: "exam.auth.",
    resourceI18nKey: "common.errors.apiCodeResources.examAuth",
    reasonCodes: [
      "avatar_must_be_image",
      "candidate_account_expired",
      "invalid_auth_mode",
      "invalid_sso_user_payload",
      "invalid_token",
      "missing_bearer_token",
      "missing_refresh_token",
      "session_invalidated",
      "site_maintenance",
      "sso_bootstrap_failed",
      "sso_integration_disabled",
      "sso_unavailable",
      "user_inactive_or_not_found",
    ],
  },
  {
    prefix: "micro_lab.auth.",
    resourceI18nKey: "common.errors.apiCodeResources.microLabAuth",
    reasonCodes: [
      "app_session_required",
      "application_access_denied",
      "application_context_invalid",
      "authorization_prompt_invalid",
      "invalid_app_session",
      "invalid_return_path",
      "invalid_sso_bff_response",
      "invalid_sso_user_payload",
      "member_access_required",
      "member_inactive",
      "oidc_request_failed",
      "oidc_transaction_missing",
      "redirect_uri_not_configured",
      "sso_bff_not_configured",
      "sso_unavailable",
    ],
  },
  {
    prefix: "platform.intelligence.auth.",
    resourceI18nKey: "common.errors.apiCodeResources.platformIntelligenceAuth",
    reasonCodes: ["invalid_app_session"],
  },
  {
    prefix: "platform.vulnerability_library.auth.",
    resourceI18nKey: "common.errors.apiCodeResources.platformVulnerabilityLibraryAuth",
    reasonCodes: ["invalid_app_session"],
  },
  {
    prefix: "redblue.auth.",
    resourceI18nKey: "common.errors.apiCodeResources.redblueAuth",
    reasonCodes: [
      "activity_member_inactive",
      "activity_role_required",
      "app_session_required",
      "application_access_denied",
      "application_context_invalid",
      "internal_actor_user_id_required",
      "internal_token_missing",
      "invalid_app_session",
      "invalid_internal_token",
      "invalid_sso_bff_response",
      "member_access_required",
      "member_inactive",
      "oidc_request_failed",
      "oidc_transaction_missing",
      "redirect_uri_not_configured",
      "sso_bff_not_configured",
    ],
  },
];
